import {StoreViewStore} from "../services/StoreViewStore";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {StoreStateParams} from "../models/StoreStateParams";
import {StateService} from "@uirouter/core";
import {StoreService} from "../services/StoreService";
import {IOnInit, IScope} from "angular";
import {StoreProductState, StoreProductStates} from "../models/StoreProductState";
import {SubscriptionUpdateRequest} from "../models/SubscriptionUpdateRequest";
import {ObjectUtil} from "../../../js/util/ObjectUtil";
import {Observable} from "rxjs";
import {CurrentUser} from "../../../services/user/models/CurrentUser";
import {StoreProductMapping} from "../models/StoreProduct";

export abstract class StoreController<T extends string> implements IOnInit {

    public abstract viewStore: StoreViewStore<T>;

    public processingOrder = false;

    protected constructor(protected $scope: IScope,
                          protected storeService: StoreService<T>,
                          protected currentUserService: CurrentUserService,
                          protected $stateParams: StoreStateParams<T>,
                          protected $state: StateService,
                          protected productMappings: StoreProductMapping<T>,
                          protected simpleModalService: any) {
    }

    public $onInit(): void {
        if (this.$stateParams.product != null) {
            this.viewStore.setProductSelected(this.$stateParams.product);
        }
    }

    public updateSubscriptions() {
        this.processingOrder = true;
        this.viewStore
            .productStates
            .take(1)
            .map((states) => this.buildSubscriptionRequests(states))
            .flatMap((requests) => this.storeService.updateSubscriptions(requests))
            .flatMap(() => this.refreshUserConfig())
            .finally(() => this.$scope.$applyAsync(() => this.processingOrder = false))
            .subscribe(() => this.purchaseComplete(), () => this.error());
    }

    protected error() {
        const lastError = "Error creating subscription.";
        this.simpleModalService.error(null, lastError);
    }

    protected buildSubscriptionRequests(states: StoreProductStates<T>): Array<SubscriptionUpdateRequest> {
        return ObjectUtil.entries(states)
                         .filter((e) => e[1].selected && !e[1].inBundle)
                         .map((e) => this.buildRequest(e[0], e[1]));
    }

    protected buildRequest(name: T, state: StoreProductState): SubscriptionUpdateRequest {
        const productDef = this.productMappings[name];
        const products = productDef.stripeProducts;
        const trial = state.hasTrialAvailable ? productDef.trial : 0;
        const coupon = productDef.coupon;
        return {
            products,
            coupon,
            trialLength: trial,
            interval: this.billingInterval()
        };
    }
    protected billingInterval(): "MONTH" | "YEAR" {
        return "MONTH";
    }
    protected refreshUserConfig(): Observable<CurrentUser> {
        const nextConfigChange$ = this.currentUserService
                                      .current
                                      .skip(1)
                                      .take(1);
        return Observable.of(true)
                         .do(() => this.currentUserService.refreshConfig())
                         .flatMap(() => nextConfigChange$);
    }

    protected purchaseComplete() {
        if (this.$stateParams.returnTo != null) {
            this.$state.go(this.$stateParams.returnTo);
        } else {
            this.$state.go("home");
        }
    }
}
